/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import FormInput from '../ContactForm/FormInput';

function ServiceContactForm({ serviceName }) {
    // STATES
    const [formData, setFormData] = useState({
        fullname: '',
        email: '',
        phone: '',
        subject: `Enquiry: ${serviceName}`,
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null); // null, 'success', or 'error'
    const [errorMessage, setErrorMessage] = useState('');

    // HANDLER
    const onChangeHandler = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        // Clear submit status when user starts typing again
        if (submitStatus) {
            setSubmitStatus(null);
            setErrorMessage('');
        }
    };

    const onSubmitHandler = async (e) => {
        e.preventDefault();

        // Basic validation
        if (!formData.fullname || !formData.email || !formData.message) {
            setSubmitStatus('error');
            setErrorMessage('Please fill in all required fields');
            return;
        }

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setSubmitStatus('error');
            setErrorMessage('Please enter a valid email address');
            return;
        }

        setIsSubmitting(true);
        setSubmitStatus(null);
        setErrorMessage('');

        try {
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (response.ok) {
                setSubmitStatus('success');
                // Reset form on success but keep the service-specific subject
                setFormData({
                    fullname: '',
                    email: '',
                    phone: '',
                    subject: `Enquiry: ${serviceName}`,
                    message: ''
                });
            } else {
                setSubmitStatus('error');
                setErrorMessage(data.error || 'Failed to send message. Please try again.');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setSubmitStatus('error');
            setErrorMessage('Network error. Please check your connection and try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="contact-form-wrapper-inline mt-5">
            <div className="mb-20">
                <span>Request a Quote</span>
                <h1>Get In Touch</h1>
            </div>

            <div className="contact-form">
                <form onSubmit={onSubmitHandler} className="row conact-form">
                                <FormInput
                                    type="text"
                                    labelFor="fullname"
                                    label="Full Name"
                                    placeholder="Enter Name"
                                    id="fullname"
                                    name="fullname"
                                    value={formData.fullname}
                                    onChange={onChangeHandler}
                                />
                                <FormInput
                                    type="email"
                                    labelFor="email"
                                    label="Email Address"
                                    placeholder="Enter Email Address"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={onChangeHandler}
                                />
                                <FormInput
                                    type="text"
                                    labelFor="phone"
                                    label="Phone Number"
                                    placeholder="Enter Number"
                                    id="phone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={onChangeHandler}
                                />

                                {/* Hidden subject field with service-specific value */}
                                <input
                                    type="hidden"
                                    name="subject"
                                    value={formData.subject}
                                />

                                <div className="col-md-12 col-12">
                                    <div className="single-personal-info">
                                        <label htmlFor="message">Enter Message</label>
                                        <textarea
                                            name="message"
                                            value={formData.message}
                                            onChange={onChangeHandler}
                                            id="message"
                                            placeholder="Tell us about your project requirements..."
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12 col-12 text-center">
                                    {submitStatus === 'success' && (
                                        <div style={{
                                            padding: '15px',
                                            marginBottom: '20px',
                                            backgroundColor: '#d4edda',
                                            color: '#155724',
                                            border: '1px solid #c3e6cb',
                                            borderRadius: '5px'
                                        }}>
                                            Thank you! Your message has been sent successfully. We'll get back to you soon.
                                        </div>
                                    )}
                                    {submitStatus === 'error' && (
                                        <div style={{
                                            padding: '15px',
                                            marginBottom: '20px',
                                            backgroundColor: '#f8d7da',
                                            color: '#721c24',
                                            border: '1px solid #f5c6cb',
                                            borderRadius: '5px'
                                        }}>
                                            {errorMessage}
                                        </div>
                                    )}
                                    <input
                                        className="submit-btn"
                                        type="submit"
                                        value={isSubmitting ? "Sending..." : "Request Quote"}
                                        disabled={isSubmitting}
                                        style={{
                                            opacity: isSubmitting ? 0.6 : 1,
                                            cursor: isSubmitting ? 'not-allowed' : 'pointer'
                                        }}
                                    />
                                </div>
                            </form>
                        </div>
        </div>
    );
}

export default ServiceContactForm;
